import { client, handleClientMethod } from "../client";
import type { PreSignedUrlResponse, UploadUrlApiResponse } from "@onsemble/shared/types/internal";

export async function getUploadUrlCsv(filename?: string): Promise<PreSignedUrlResponse> {
  const response = await handleClientMethod<UploadUrlApiResponse>(
    client.POST("/api/internal/products/upload/csv", {
      params: {
        query: filename ? { filename } : {},
      },
    })
  );
  return response.data;
}

export async function getUploadUrlSpec(filename?: string): Promise<PreSignedUrlResponse> {
  const response = await handleClientMethod<UploadUrlApiResponse>(
    client.POST("/api/internal/products/upload/spec", {
      params: {
        query: filename ? { filename } : {},
      },
    })
  );
  return response.data;
}
